import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { update_event_selection } from '@rpt-ngrx/actions/events.action';
import { IOpenReportHistory } from '@shared/types';
import { IEventState } from '@shared/types/event';

@Injectable({
    providedIn: 'root',
})
export class EventPickerService {
    constructor(private store: Store) {}

    public resetEventMainFilter(eventState: IEventState, history: IOpenReportHistory, reportId: string): void {
        const eventsOrderDateRange = eventState.eventsOrderDateRange;
        if (!history.filters || history.filters.Event_Id === 'None') {
            return;
        }
        const selectedEvents =
            history.filters.Event_Id === 'All'
                ? eventState.events
                : Array.isArray(history.filters.Event_Id)
                  ? eventState.events.filter((event) =>
                        (history.filters.Event_Id as Array<string>).some((id) => id === event.id || id === event.name),
                    )
                  : [
                        eventState.events.find(
                            (event) => event.id === history.filters.Event_Id || event.name === history.filters.Event_Id,
                        ),
                    ];
        const pathParam = history.additional_path_parameters.find((param) => param.type === 'events') || {
            multiple: true,
        };
        const resolvedEvents = selectedEvents.filter(Boolean);
        if (!resolvedEvents.length) {
            return;
        }
        this.store.dispatch(
            update_event_selection({
                events: resolvedEvents.map((event) => {
                    const { event_days } = event;
                    const { order_start_date, order_end_date } = eventsOrderDateRange[event.id] || {};

                    return {
                        id: event.id,
                        name: event.name,
                        event_day_ordering: {
                            end_date_time: event.event_day_ordering.end_date_time,
                            start_date_time: event.event_day_ordering.start_date_time,
                        },
                        event_days,
                        order_dates: order_start_date ? [order_start_date, order_end_date] : [],
                    };
                }),
                isMultiple: pathParam.multiple,
                reportId,
            }),
        );
    }
}
